import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import { webSavedSearchAuthenticatedLimit } from '@Components/Utilities/SandhillsConstants';
import translator from '@Components/Utilities/Translator';
import { useRecoilState, useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';
import WebSavedSearchesModal from '@Components/Shared/Modals/WebSavedSearchesModal' ;

const WebSavedSearchesButton = (props) => {

    const [currentUser, setCurrentUser] = useRecoilState(atoms.currentUser);
    const currentWebsite = useRecoilValue(atoms.currentWebsite);

    return (
        <>
            {(props.Loading && !props.ShowModal) && <LoadingRing sxBox={{ 'justify-content': 'center' }} backdrop />}
            <div className='saved-searches__buttons'>
                {(!props.IsDefaultSearch || (props.IsDefaultSearch && currentWebsite?.Site?.IsBidcaller)) && !props.TurnOffDefaultSaveThisSearch &&
                    <button className={currentUser.IsAuthenticated ? '' : 'full'} onClick={(e) => props.openModal(e, true)}>
                        <i className="fa fa-regular fa-heart"></i>
                        <span>{translator.translate('sandhills.savethissearch')}</span>
                    </button>                    
                }
                {currentUser.IsAuthenticated &&
                    <button className={!props.IsDefaultSearch ? props.TurnOffDefaultSaveThisSearch ? 'full' : '' : 'full'} onClick={(e) => props.openModal(e, false)}>
                        {translator.translate('sandhills.savedsearches')}
                    </button>
                }
            </div>
            {props.ShowModal &&
                <WebSavedSearchesModal {...props}
                    PendingSave={props.PendingSave}
                    Loading={props.Loading && props.ShowModal} onClose={props.closeModal} />
            }
        </>
    );
};

export default WebSavedSearchesButton;